import { render, staticRenderFns } from "./HazmatView.vue?vue&type=template&id=5fe8494d&scoped=true&"
import script from "./HazmatView.vue?vue&type=script&lang=js&"
export * from "./HazmatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8494d",
  null
  
)

export default component.exports